
import { defineComponent } from "vue";
import QrcodeVue from "qrcode.vue";
import Dialog from "vant/es/dialog";
import "vant/es/dialog/style";

interface TypeQrcodeInfo {
  url: string;
  desc: string;
}

export default defineComponent({
  nane: "QrcodeBox",
  props: {
    qrcodeInfo: {
      type: Object,
      required: true
    }
  },
  components: { QrcodeVue, [Dialog.Component.name]: Dialog.Component },
  methods: {
    longtapHandler() {
      Dialog.confirm({
        title: "",
        message: "已识别出该溯源二维码，是否要跳转到对应的溯源平台查看详细信息?"
      }).then(() => {
        window.location.href = this.qrcodeInfo.url;
      });
    }
  }
});
